import React from 'react';
import FavoritesApi from '../../lib/FavoritesApi';
import FlashMessage from '../../components/LoadingWrapper/FlashMessage';
import Config from '../../Config';
import { AudioLessonData, AudioStream, Identifier } from '../../types';
import AnalyticsHelper from '../../lib/AnalyticsHelper';

declare global {
    interface Window {
        jQuery: any,
        initPlayer: any,
        checkIOS: any,
        teardownPlayer: any,
        openNativePlayer?: any,
        onArkPlayerEvent: any,
    }
}

type Props = {
    lesson: AudioLessonData,
    lessonId: Identifier,
    onNativePlayer: () => void,
};

type StreamQuality = 'hq' | 'lq';

type State = {
    isFavorit: boolean,
    voiceIndex: number,
    selectedStreamType: StreamQuality,
    messages: Array<string>,
};

class AudioPlayer extends React.Component<Props, State> {
    // playerEl? : HTMLDivElement = undefined;
    constructor(props: Props) {
        super(props);
        this.state = {
            isFavorit: props.lesson.isFavorit,
            selectedStreamType: 'lq',
            voiceIndex: 0,
            messages: [],
        };
    }

    componentDidMount() {
        const { lesson } = this.props;

        AnalyticsHelper.trackOpenPlayerEvent(lesson.title);

        if (window.openNativePlayer) {
            const { lessonId, onNativePlayer } = this.props;

            window.openNativePlayer(lesson.title,
                lesson.streams,
                lesson.isFavorit,
                (isFavorit: boolean) => {
                    const method = isFavorit ? 'addFavorite' : 'deleteFavorite';
                    FavoritesApi[method](lessonId)
                        .catch(() => { });
                });

            onNativePlayer();
            return;
        }

        window.checkIOS(window.jQuery);
        window.initPlayer(window.jQuery);

        this.attachArkPlayerEvent();

        document.documentElement.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        if (window.teardownPlayer) {
            window.teardownPlayer(window.jQuery);
        }

        window.onArkPlayerEvent = undefined;

        document.documentElement.style.overflow = '';
    }

    getTrackFromStream(stream: AudioStream, hq: boolean = false): string {
        const { voiceIndex } = this.state;

        const index = stream.type === 'voice' ? voiceIndex : 0;
        const urls = hq ? stream.urlsHq : stream.urlsLq;

        return urls[index];
    }

    attachArkPlayerEvent() {
        const { lesson } = this.props;

        window.onArkPlayerEvent = (eventtype: string) => {
            if (eventtype === 'play') {
                AnalyticsHelper.trackPlayEvent(lesson.title);
            }
        };
    }

    toggleFavorit() {
        const previousFavorite = this.state.isFavorit;
        this.setState(prev => ({ isFavorit: !prev.isFavorit }));

        const method = previousFavorite ? 'deleteFavorite' : 'addFavorite';

        FavoritesApi[method](this.props.lessonId)
            .catch(() => this.setState(prev => ({
                messages: [...prev.messages, 'Titel konnte nicht zu den Favoriten hinzugefügt werden'],
                isFavorit: previousFavorite,
            })));
    }

    renderStreams() {
        const { lesson } = this.props;

        return lesson.streams.map((stream: AudioStream) => (
            <div className={`ark-ex-track ${stream.color}`}>
                <div
                    className="ark-ex-play"
                    data-track={this.getTrackFromStream(stream)}
                    data-track-hq={this.getTrackFromStream(stream, true)}
                    data-active={stream.active ? 1 : 0}
                >
                    <div className="ark-ex-title">{stream.title}</div>
                </div>
                <div className="ark-ex-vol">
                    <div className="master" />
                    <span className="vol-display" style={{ display: 'none' }} />
                    <span className="vol-before-mute" style={{ display: 'none' }} />
                </div>
            </div>
        ));
    }

    /**
     * Render all the messages in the message queue
     */
    renderMessages() {
        return this.state.messages.map(message => (
            <FlashMessage message={message} type="error" />
        ));
    }

    render() {
        const { lesson } = this.props;
        const { playerLayout } = lesson;
        const { isFavorit } = this.state;

        return (
            <div
                className="audio-player-window"
                style={{
                    backgroundColor: playerLayout.bodyColor.bgColor,
                    color: playerLayout.bodyColor.fontColor,
                    backgroundImage: `url(${playerLayout.headerWaveUrl})`,
                }}
            >
                <div className="vc_row wpb_row section vc_row-fluid">
                    <div className=" full_section_inner clearfix">
                        <div className="wpb_column vc_column_container vc_col-sm-12" id="ark-player-outer">
                            <div className="vc_column-inner ">
                                <div className="wpb_wrapper ark-player-box">
                                    <div id="ark-ios-check">
                                        <p className="ark-ios-check-msg">Wir haben gerade bemerkt, dass du ein Apple Gerät benutzt. Um alle eleMental Funktionen nutzen zu können, lade bitte unsere App im Appstore.</p>
                                    </div>
                                    <div id="ark-player" data-setup="0-1">
                                        <div id="ark-player-main">
                                            <div id="ark-play">
                                                <div className="ark-i-play" aria-hidden="true">
                                                    <img src="https://elemental-app.com/wp-content/plugins/arket-player/assets/player-start.svg" alt="" />
                                                </div>
                                                <div className="ark-i-pause" aria-hidden="true">
                                                    <img src="https://elemental-app.com/wp-content/plugins/arket-player/assets/player-pause.svg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ark-player-container">
                                            <div id="ark-player-timeline">
                                                <div id="ark-player-timeline-bar">
                                                    <input type="range" min="0" max="100" value="0" id="ark-timeline-slider" />
                                                </div>
                                                <div id="ark-timeline-time">
                                                    <div id="ark-timeline-done">00:00</div>
                                                    {' '}
                                                    /
                                                    <div id="ark-timeline-full">00:00</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="ark-cog" className="active">
                                        <img src={`${Config.publicImageUrl}/images/icon_player_settings_inactive.svg`} alt="" className="ark-cog-off active" />
                                        <img src={`${Config.publicImageUrl}/images/icon_player_settings_active.svg`} alt="" className="ark-cog-on" />
                                    </div>
                                    <div id="ark-settings">
                                        <div className="ark-setting-container">
                                            <button className="icon" onClick={() => this.toggleFavorit()} type="button">
                                                <i className={`icon icon-favorite${isFavorit ? '-active' : ''}`} />
                                                <span>Fav.</span>
                                            </button>
                                        </div>
                                        {this.renderStreams()}
                                        <div className="ark-setting-container">
                                            <div id="ark-quality">
                                                <h6>Qualität</h6>
                                                <div id="ark-qual">normal</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderMessages()}
            </div>
        );
    }
}

export default AudioPlayer;
